import React from 'react'
import { storiesOf } from '@storybook/react'
import { withKnobs, boolean } from '@storybook/addon-knobs/react'

import Typography from '@material-ui/core/Typography'
import { withRouter } from 'react-router'
import { withState } from 'recompose'

import ResponsiveJerseyFrame
  from 'routes/SelectStake/SelectStakeScreen/components/SelectStake/components/ResponsiveJerseyFrame'
import EntryFeePicker from 'routes/SelectStake/SelectStakeScreen/components/SelectStake/components/EntryFeePicker'
import TopChoice from 'routes/SelectStake/SelectStakeScreen/components/SelectStake/components/TopChoice'
import SelectStakeScreen from 'routes/SelectStake/SelectStakeScreen'
import SelectStake from 'routes/SelectStake/SelectStakeScreen/components/SelectStake'
import { GamePrizeInfoResponse, MatchDetailsResponse, CreateGameResponse, GameType } from 'protos'

// fake data

const m = (value: number) => ({ value })
const fakeGamePrizeInfoResponse = GamePrizeInfoResponse.fromObject({
  feeOption: [
    { entryFee: m(1), maxPot: m(20), highlight: GamePrizeInfoResponse.Highlight.FOH_NONE },
    { entryFee: m(25), maxPot: m(100), highlight: GamePrizeInfoResponse.Highlight.FOH_TOP },
    { entryFee: m(50), maxPot: m(600), highlight: GamePrizeInfoResponse.Highlight.FOH_NONE },
    { entryFee: m(100), maxPot: m(1000), highlight: GamePrizeInfoResponse.Highlight.FOH_NONE },
    { entryFee: m(5000), maxPot: m(10000), highlight: GamePrizeInfoResponse.Highlight.FOH_NONE },
  ],
  defaultFeeOptionIndex: 1,
})

const fakeMatchDetailsResponse = MatchDetailsResponse.fromObject({
  match: {
    homeTeam: {
      jersey: {
        baseColor: 'b00000',
        numberColor: 'ffffff',
        sleeveColor: '0000b0',
      },
    },
    awayTeam: {
      jersey: {
        baseColor: 'ffff00',
        numberColor: 'cc0000',
        sleeveColor: 'ffa500',
      },
    },
  },
})

const fakeCreateGameResponse = CreateGameResponse.fromObject({
  result: CreateGameResponse.Result.CGR_SUCCESS,
  gameId: '1234',
})

// stories

const stories = storiesOf('SelectStakeScreen', module)
stories.addDecorator(withKnobs)

stories
  .add('SelectStakeScreen', () => {
    const SelectStakeScreenContainer = withRouter(SelectStakeScreen)

    return (
      <div>
        <SelectStakeScreenContainer
          balance={200}
          gameType={GameType.GT_AUTO_MM}
          getGamePrizeInfo={() => Promise.resolve(fakeGamePrizeInfoResponse)}
          getMatchDetails={() => Promise.resolve(fakeMatchDetailsResponse)}
          onEntryFeeSelect={(entryFee) => Promise.resolve(fakeCreateGameResponse)}
        />
      </div>
    )
  })
  .add('SelectStake', () => {
    return (
      <div>
        <SelectStake
          balance={200}
          selectedMatch={fakeMatchDetailsResponse.match!}
          feeOptions={fakeGamePrizeInfoResponse.feeOption}
          selectedFeeIndex={0}
          isBalanceSufficient={true}
          setSelectedFeeIndex={() => { /* */ }}
        />
      </div>
    )
  })

const substories = storiesOf('SelectStakeScreen/components', module)
substories.addDecorator(withKnobs)

substories
  .add('EntryFeePicker', () => {
    const isBalanceSufficient = boolean('isBalanceSufficient', true)

    /* tslint:disable-next-line:no-any */
    const EntryFeePickerContainer: any = withState('selectedIndex', 'onChange', 0)(EntryFeePicker as any)

    return (
      <EntryFeePickerContainer
        feeOptions={fakeGamePrizeInfoResponse.feeOption}
        isBalanceSufficient={isBalanceSufficient}
      />
    )
  })
  .add('ResponsiveJerseyFrame', () => {
    return (
      <div>
        <ResponsiveJerseyFrame homeJersey={{}} awayJersey={{}}>
          <Typography variant="h5" align="center">Content between the jerseys</Typography>
        </ResponsiveJerseyFrame>
      </div>
    )
  })
  .add('TopChoice', () => {
    return (
      <div>
        <TopChoice feeOption={fakeGamePrizeInfoResponse.feeOption[0]} />
        <TopChoice feeOption={fakeGamePrizeInfoResponse.feeOption[1]} />
      </div>
    )
  })
